import { useTableLayoutPosition } from '@/components/GameAssets/Table/useTableLayout'
import React, { PropsWithChildren, ReactElement, useMemo } from 'react'
import { View, StyleSheet, ViewStyle } from 'react-native'
import { createComponent } from 'react-native-small-ui'

const Box = createComponent(View, {
  flexGrow: 1
})

type Board = PropsWithChildren<{
  containerStyle?: ViewStyle
  //
  headerComponent?: React.ReactNode
  footerComponent?: React.ReactNode
}>

export const Board = ({ children, containerStyle, headerComponent, footerComponent }: Board) => {
  const layout = useTableLayoutPosition()
  const width = layout.innerTable.width
  const containerPadding = layout.padding * 2
  const headerHeight = layout.seats.height * 2 - layout.seatsLayout.topSpacer + containerPadding

  return (
    <Box
      alignItems="center"
      flexShrink={1}
      flexGrow={0}
      paddingVertical={containerPadding}
      // backgroundColor={'#0ff6'}
      style={containerStyle}
    >
      <BoardHeader
        // backgroundColor={'#f0f4'}
        width={'100%'}
        minWidth={width}
        minHeight={headerHeight}
        padding={layout.padding}
        paddingHorizontal={layout.chips.size}
      >
        {headerComponent}
      </BoardHeader>

      <BoardContent
        // backgroundColor={'#0f0'}
        minHeight={layout.boardSpaceForCard.height}
      >
        {children}
      </BoardContent>

      <BoardFooter
        // backgroundColor={'#00f4'}
        width={'100%'}
        minWidth={width}
        minHeight={headerHeight}
        padding={layout.padding}
      >
        {footerComponent}
      </BoardFooter>
    </Box>
  )
}

const BoardHeader = createComponent(View, {
  minHeight: 44
})
const BoardContent = createComponent(View, {
  width: '100%',
  justifyContent: 'center',
  gap: 24,
  minHeight: 80
})
const BoardFooter = createComponent(View, {
  minHeight: 44
})

export type SeatAlignment = 'right' | 'left' | 'top' | 'bottom'
export type SeatContentFunction = (seatId: number, alignment: SeatAlignment) => ReactElement | null

type PlayerSeatsProps = {
  seatContent: SeatContentFunction
  seatStyle?: Exclude<ViewStyle, 'top' | 'right' | 'left' | 'marginLeft' | 'transform'>
  preset?: 'none' | 'dashed' | 'dotted'
}

export const PlayerSeats = ({ seatContent, seatStyle, preset = 'none' }: PlayerSeatsProps) => {
  const { seatsLayout, ...layout } = useTableLayoutPosition()

  const presetStyle = useMemo(() => {
    switch (preset) {
      case 'dotted':
        return seatsPresetStyles.dottedStyle
      case 'dashed':
        return seatsPresetStyles.dashedStyle
      case 'none':
        return undefined
    }
  }, [preset])

  return (
    <>
      {seatsLayout.positions.map((seat) => (
        <Box
          key={`seat-${seat.seatId}`}
          flexShrink={1}
          borderRadius={layout.seats.borderRadius}
          width={layout.seats.width}
          maxWidth={160}
          height={layout.seats.height}
          position="absolute"
          zIndex={1}
          style={[seat?.style, presetStyle, seatStyle]}
        >
          {seatContent(seat.seatId, seat.alignment)}
        </Box>
      ))}
    </>
  )
}

const seatsPresetStyles = StyleSheet.create({
  dashedStyle: {
    borderStyle: 'dashed',
    borderWidth: 0.5,
    // borderColor: '#00000077'
    borderColor: '#660334'
  },
  dottedStyle: {
    borderStyle: 'dotted',
    borderWidth: 0.5,
    // borderColor: '#00000077'
    borderColor: '#660334'
  }
})
